import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../lib/services/analytics-service';

/**
 * Hook to automatically track page views when route changes
 */
export function usePageTracking() {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Track page view on route change
    trackPageView({
      route: location.pathname,
      search: location.search,
      hash: location.hash
    });
  }, [location, trackPageView]);
}

export default usePageTracking;
